import * as React from 'react';

import classNames from 'classnames';

import {getRandomInt} from '../utils/numbers';

import styles from './loading-text.module.css';

type Props = {
    color?: string;
    height?: number;
    minWidth?: number;
    maxWidth?: number;
    width?: number;
    isFullWidth?: boolean;
    isAnimated?: boolean;
    isRounded?: boolean;
    opacity?: number;
};

export function LoadingText(props: Props) {
    const {
        color = '#e1e1e1',
        height = 15,
        minWidth = 30,
        maxWidth = 160,
        isFullWidth = false,
        isAnimated = true,
        isRounded = true,
        opacity = 1,
    } = props;

    const calculatedStyles = {
        backgroundColor: color,
        height,
        width: isFullWidth ? '100%' : props.width || getRandomInt(minWidth, maxWidth),
        '--base-opacity': opacity,
        opacity: isAnimated ? undefined : opacity,
    } as const;

    const className = classNames(styles['loading-text-placeholder'], {
        [styles['loading-text-animated']]: isAnimated,

        'br-3': isRounded,
    });

    return <div className={className} style={calculatedStyles} />;
}
